function quickShopModalFunction() {
  let btns = [];
  const closeBtns = document.querySelectorAll('.quickshop .close__btn');
  const modals = document.querySelectorAll('.quickshop.modal');

  btns = document.querySelectorAll('.quick__shop-btn');

  btns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      const prodId = e.target.dataset.id;
      const modal = document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`);

      const overlay = document.createElement('div');
      overlay.classList.add('overlay');

      overlay.addEventListener("click", () => {
        document.documentElement.style.overflowY = "unset";
        document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`).classList.add('hidden');
        document.querySelectorAll('.overlay').forEach((overlay) => overlay.remove());
      });
      
      document.body.appendChild(overlay);
      document.documentElement.style.overflowY = "hidden";
      modal.classList.remove('hidden');

      modal.querySelectorAll('input[type="radio"][checked]').forEach((radio) => {
        radio.nextElementSibling.click();
      });
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.target.closest('.quickshop').classList.add('hidden');
      document.querySelector('.overlay').remove();
      document.documentElement.style.overflowY = "unset";
    });
  });

  modals.forEach(modal => {
    const submit = modal.querySelector('.product-form__buttons button');

    submit.addEventListener('click', (e) => {
      const error = document.querySelector('.quickshop:not(.hidden) .product-form__error-message-wrapper');
      const errorMessage = document.querySelector('.quickshop:not(.hidden) .product-form__error-message');
      const prod = modal.querySelector('.product__title').dataset.handle.toLowerCase().split(" ").join('-');
      const checkedOption = modal.querySelector('.quickshop.modal .product-form__input input:checked');
      const cartNotification = document.querySelector('cart-notification');

      const sellingPlanID = submit.getAttribute('data-selling-plan-id');

      // Fetch product data
      fetch(`/products/${prod}.js`)
        .then(response => response.json())
        .then(product => {
          const prodVariants = product.variants;

          // Fetch cart data
          return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              let quantity = modal.querySelector('.quantity__input').value;
              quantity = parseInt(quantity);
              let variantId = '';
              let availability = false;

              prodVariants.forEach(variant => {
                if (checkedOption) {
                  if (variant.title === checkedOption.value) {
                    variantId = variant.id;
                    availability = variant.available;
                  }
                } else {
                  variantId = product.variants[0].id;
                  availability = product.variants[0].available;
                }
              });

              if (availability) {
                error.classList.add('hidden');

                let bodyConfig = {
                  items: [{
                    id: variantId,
                    quantity: quantity
                  }]
                }      
          
                if (sellingPlanID) {
                  bodyConfig = {
                    items: [{
                      id: variantId,
                      quantity: quantity,
                      selling_plan: sellingPlanID
                    }]
                  }
                }

                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(bodyConfig)
                })
                  .then(response => {
                    if (!response.ok) {
                      return response.json().then(errorData => {
                        throw new Error(errorData.message || errorData.description || 'Failed to add item to cart');
                      });
                    }
                    return response.json();
                  })
                  .then(data => {
                    e.target.closest('.quickshop').classList.add('hidden');
                    document.documentElement.style.overflowY = "unset";
                    document.querySelector('.overlay').remove();
                    if (cartNotification) {
                      cartNotification.productJustAddedToCartByQuickAdd();
                    }
                  })
                  .catch((err) => {
                    console.error('Error:', err);
                    error.classList.remove('hidden');
                    errorMessage.innerText = err.message || 'An error occurred while adding the item to cart';
                    e.preventDefault();
                  });
              } else {
                error.classList.remove('hidden');
                errorMessage.innerText = 'The product is sold out';
              }
            });
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          e.preventDefault();
        });
    });
  });
}

function blurBadges() {
  const buttons = document.querySelectorAll('.quick__shop-btn');
  buttons.forEach(btn => {
    btn.addEventListener('mouseenter', function () {
      const badge = this.parentElement.querySelector('.knesko-card__badge');
      if (badge) badge.classList.add('blur');
    });
    btn.addEventListener('mouseleave', function () {
      const badge = this.parentElement.querySelector('.knesko-card__badge');
      if (badge) badge.classList.remove('blur');
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  quickShopModalFunction();
  // blurBadges();
});
